<nav id="headerNav" class="navbar navbar-default" role="navigation">
	<div class="container-fluid">
		<!-- BURGER ICON -->
	    <div class="navbar-header">
	      <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#header-collapse" aria-expanded="false">
	        <span class="sr-only">Toggle navigation</span>
	        <span class="icon-bar"></span>
	        <span class="icon-bar"></span>
	        <span class="icon-bar"></span>
		</button>
		<a class="mobile-logo" href="{{externalBaseUrl}}/home">
			<img src="/ms-gulphq/resources/dest{{contextPath}}/images/{{logoToUse}}" style="width:257px;">
		</a>
	    </div>

		<!-- NAVIGATION -->
	    <div class="collapse navbar-collapse" id="header-collapse">
			<!-- USER LOGIN LINKS -->
			<div class="container user-nav-container">
				<div class="row user-nav-row">
					<div class="container">
						<div class = "col-xs-12">
							<ul id="loginLinksView" class="pull-right nav navbar-nav login-links"></ul>
						</div>
					</div>
				</div>
			</div>
<!-- 			<div class="container"> -->
<!-- 				<div class="row header-row"> -->
<!-- 					<div class="hidden-xs col-sm-3"> -->
<!-- 						BRAND -->
<!-- 					 <a class="logo" href="{{contextPath}}/home"> -->
<!-- 						<img src="/ms-gulphq/resources/dest{{contextPath}}/images/logo.png" style="width:257px;"> -->
<!-- 					 </a> -->
<!-- 				 	</div> -->
<!-- 					<div class="col-xs-12 col-md-9"> -->
<!-- 						<div class="row search-row text-right"> -->
<!-- 							SEARCH -->
<!-- 				  			<div id="headerSearchInputView" class="pull-right header-search"></div> -->
<!-- 						</div> -->
<!-- 						<div class="row site-nav-row text-right"> -->
<!-- 							SITE NAVIGATION -->
<!-- 							<div id="navBarView" class="main-nav"></div> -->
<!-- 						</div> -->
<!-- 					</div> -->
<!-- 				</div> -->
<!-- 			</div> -->
		</div>
	</div>
</nav>
